import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchCustomers } from '../actions/customers';
import { fetchMachines } from '../actions/machines';
import { fetchLockerQty } from '../actions/objectives';
import { renderSelectField } from '../utils/forms';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import LoadingProgress from '../components/LoadingProgress';

class LockerQtyFilterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loaded: false };
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.props.fetchCustomers();
    this.props.fetchMachines();
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(props) {
    const { customers } = props;
    if (!this.state.loaded && customers) {
      this.setState({ loaded: true });
    }
  }

  submit(props) {
    if (!props.Customer || !props.Year) {
      throw new SubmissionError({
        _error: 'Customer and Year are required.'
      });
    }

    return this.props.fetchLockerQty(props.Customer, props.Year, props.Machine);
  }

  render() {
    const { handleSubmit, customers, machines, formValues, error } = this.props;

    if (!Array.isArray(customers)) {
      return (
        <LoadingProgress />
      );
    }

    if (!Array.isArray(machines)) {
      return (
        <LoadingProgress />
      );
    }

    const selectedCustomer = formValues.Customer;
    const filteredMachines = machines.filter(
      m => !selectedCustomer || (m.Customer && m.Customer._id === selectedCustomer)
    );

    return (
      <form onSubmit={handleSubmit(this.submit)} className="mb-3">
        <div className="row">
          <div className="col">
            <Field
              name="Customer"
              component={renderSelectField}
              label="Cliente"
            >
              <option value="">Todos</option>
              {customers
                .filter((customer) => customer.Type === 'GENERAL' || customer.Type === 'LICENCIA_BASICA' || customer.Type === 'LICENCIA_PRO')
                .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                .map((customer) => (
                  <option value={customer._id} key={customer._id}>
                    {customer.Fullname}
                  </option>
                ))}
            </Field>
          </div>
          <div className="col">
            <Field
              name="Machine"
              component={renderSelectField}
              label="Máquina"
              disabled={!selectedCustomer}
            >
              <option value="">Todas</option>
              {filteredMachines.map((machine) => (
                <option value={machine._id} key={machine._id}>
                  {machine.Serial} - {machine.Customer?.Fullname || 'Sin cliente'}
                </option>
              ))}
            </Field>
          </div>
          <div className="col">
            <Field name="Year" component={renderSelectField} label="Año">
              {[...Array(10)].map((_, i) => {
                const year = new Date().getFullYear() - i;
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        {error && (
          <div className="alert alert-danger mt-2">
            {error}
          </div>
        )}
        <div className="form-row justify-content-center mt-2">
          <button type="submit" className="btn bg-vw-dark text-white">
            <i className="fas fa-sync mr-1"></i>Cargar
          </button>
        </div>
      </form>
    );
  }
}

LockerQtyFilterForm = reduxForm({
  form: 'LockerQtyFilterForm'
})(LockerQtyFilterForm);

const selector = formValueSelector('LockerQtyFilterForm');

const mapStateToProps = state => ({
  customers: state.customers.customers,
  machines: state.machines.machines,
  role: state.auth.role,
  initialValues: {
    Customer: '',
    Year: new Date().getFullYear().toString()
  },
  formValues: {
    Customer: selector(state, 'Customer'),
    Year: selector(state, 'Year')
  }
});

const mapDispatchToProps = dispatch => ({
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchLockerQty: bindActionCreators(fetchLockerQty, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LockerQtyFilterForm);
